import Vue from 'vue'
import VueRouter from 'vue-router'
import TextArea from '../components/pages/TextArea.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: TextArea
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
